// Hook - dashboard handlowca: KPI strip + 3 kolejki + filters_meta
// GET /api/ui/trader/insights/dashboard

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type {
  IGetTraderInsightsDashboardParams,
  IGetTraderInsightsDashboardResponse,
} from 'api/types/traderInsights';

const getTraderInsightsDashboard = (
  params: IGetTraderInsightsDashboardParams
): Promise<IGetTraderInsightsDashboardResponse> =>
  axios.get('/trader/insights/dashboard', { params });

export const useGetTraderInsightsDashboard = (
  params: IGetTraderInsightsDashboardParams = {},
  options?: UseQueryOptions<IGetTraderInsightsDashboardResponse, IError>
) =>
  useQuery<IGetTraderInsightsDashboardResponse, IError>(
    ['trader-insights-dashboard', params],
    () => getTraderInsightsDashboard(params),
    options
  );
